import React,{Component,useEffect,useState} from 'react';
import {auth,data} from '../firebase';
import '../css/Searc.css';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import LocationOnIcon from '@material-ui/icons/LocationOn';

var c=0;
function Searc() {
    
    const [usesa,setUs]=useState([]);
    useEffect(()=>{
        get();
    },[])
    function get() {
        data.collection("Products").get().then((item)=> {
            const items =item.docs.map((doc)=>doc.data());
            
            setUs(items)
        });
        
    }
    console.log("o")
    var ara=[];
        const a =window.location.href;
        const b =new URLSearchParams(a)
        for(const [key,value] of b){
            ara.push(value);
        }
        
    if(ara.length>1){
        return (
            <div className="BOXS">
                {usesa.filter((val)=>{
                    if((ara[0]=="" || val.title.toLowerCase().split(" ").includes(ara[0].toLowerCase())) && (ara[2]==0 || val.type.toLowerCase().includes(ara[2].toLowerCase())) && (ara[1]==3 || val.city.toLowerCase().includes(ara[1].toLowerCase()))){
                        
                        return val;
                    }
                }).map((e,index)=>{
                    var link = "/Product/"+e.id
                    return(
                    <a className="conatiner" href={link}>
                        
                        <div className="image">
                            <img src={e.img}/>
                        </div>
                        <div className="textfield">
                            <p className="prix">{e.prix}</p>
                            <p className="title">{e.title}</p>
                            <div className="Bottomtext">
                                <p className="type">{e.type}</p>
                                <div className="line"></div>
                                <div className="datecity">
                                    <div>
                                        <WatchLaterIcon />
                                        <p className="date">{e.Day}/{e.DayNum}</p>
                                    </div>
                                    <div>
                                        <LocationOnIcon />
                                        <p className="city">{e.city}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </a>)
                })}
                
            </div>
            
        )
    }else{
        window.location.replace("/")
        return null
    }
}

export default Searc
